/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  Comment,
  CommentReply,
  List,
  OrganizationMember,
  PostCommentReplySchema,
  PostCommentSchema,
  UpdateCommentReplySchema,
  UpdateCommentSchema,
} from "./data-contracts";

/**
 * No description
 * @tags space-comments, critical
 * @name ListCommentsInSpace
 * @summary List all space comments
 * @request GET:/spaces/{spaceId}/comments
 * @secure
 */

// @ts-ignore
export const listCommentsInSpace: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
    /**
     * When provided, only comments with the given status are returned. Defaults to "all".
     * @default "all"
     */
    status?: "all" | "open" | "resolved";
    /** Output format for the content. */
    format?: "document" | "markdown";
    /** The target page of the comment */
    targetPage?: string;
    /** User IDs to filter queried comments on */
    authors?: string[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Comment[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments",
  method: "get",
  streaming: false,
  tags: ["space-comments", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags space-comments
 * @name PostCommentInSpace
 * @summary Create a space comment
 * @request POST:/spaces/{spaceId}/comments
 * @secure
 */

// @ts-ignore
export const postCommentInSpace: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: PostCommentSchema;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments",
  method: "post",
  streaming: false,
  tags: ["space-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-comments
 * @name GetCommentInSpace
 * @summary Get a space comment
 * @request GET:/spaces/{spaceId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const getCommentInSpace: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the comment */
    commentId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}",
  method: "get",
  streaming: false,
  tags: ["space-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-comments
 * @name DeleteCommentInSpace
 * @summary Delete a space comment
 * @request DELETE:/spaces/{spaceId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const deleteCommentInSpace: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the comment */
    commentId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}",
  method: "delete",
  streaming: false,
  tags: ["space-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-comments
 * @name UpdateCommentInSpace
 * @summary Update a space comment
 * @request PUT:/spaces/{spaceId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const updateCommentInSpace: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the comment */
    commentId: string;
  };
  RequestQuery: {};
  RequestBody: UpdateCommentSchema;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}",
  method: "put",
  streaming: false,
  tags: ["space-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-comments
 * @name PostCommentReplyInSpace
 * @summary Create a space comment reply
 * @request POST:/spaces/{spaceId}/comments/{commentId}/replies
 * @secure
 */

// @ts-ignore
export const postCommentReplyInSpace: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the comment */
    commentId: string;
  };
  RequestQuery: {};
  RequestBody: PostCommentReplySchema;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}/replies",
  method: "post",
  streaming: false,
  tags: ["space-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-comments
 * @name GetCommentReplyInSpace
 * @summary Get a space comment reply
 * @request GET:/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const getCommentReplyInSpace: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the comment */
    commentId: string;
    /** The unique id of the comment reply */
    commentReplyId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}",
  method: "get",
  streaming: false,
  tags: ["space-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-comments
 * @name UpdateCommentReplyInSpace
 * @summary Update a space comment reply
 * @request PUT:/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const updateCommentReplyInSpace: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the comment */
    commentId: string;
    /** The unique id of the comment reply */
    commentReplyId: string;
  };
  RequestQuery: {};
  RequestBody: UpdateCommentReplySchema;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}",
  method: "put",
  streaming: false,
  tags: ["space-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-comments
 * @name DeleteCommentReplyInSpace
 * @summary Delete a space comment reply
 * @request DELETE:/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const deleteCommentReplyInSpace: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the comment */
    commentId: string;
    /** The unique id of the comment reply */
    commentReplyId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}",
  method: "delete",
  streaming: false,
  tags: ["space-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-comments, critical
 * @name ListCommentersInSpace
 * @summary List all users who commented in a space
 * @request GET:/spaces/{spaceId}/commenters
 * @secure
 */

// @ts-ignore
export const listCommentersInSpace: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OrganizationMember[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/commenters",
  method: "get",
  streaming: false,
  tags: ["space-comments", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};
